import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { KycFooter } from "./KycFooter";
import { KycHeader } from "./KycHeader";

export function KycLayout() {
  useEffect(() => {
    document.title = "IdentityVerify — Secure identity verification";
  }, []);

  return (
    <div className="kyc-portal flex min-h-0 flex-col gap-5 overflow-hidden text-slate-950">
      <KycHeader />
      <main className="kyc-portal-main relative z-10 flex min-h-0 min-w-0 flex-1 overflow-hidden">
        <Outlet />
      </main>
      <KycFooter />
    </div>
  );
}
